import { render, staticRenderFns } from "./AttributionPackageList.vue?vue&type=template&id=05935f96"
import script from "./AttributionPackageList.vue?vue&type=script&lang=js"
export * from "./AttributionPackageList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports